var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBinFilled = function SvgBinFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 17.7676C5.37467 17.7676 4.98245 17.5955 4.65634 17.2513C4.33023 16.907 4.1669 16.4927 4.16634 16.0083V4.57315H3.33301V2.81389H7.49967V1.93427H12.4997V2.81389H16.6663V4.57315H15.833V16.0083C15.833 16.4921 15.67 16.9064 15.3438 17.2513C15.0177 17.5961 14.6252 17.7682 14.1663 17.7676H5.83301ZM7.49967 14.2491H9.16634V6.33241H7.49967V14.2491ZM10.833 14.2491H12.4997V6.33241H10.833V14.2491Z"
  })));
};
export default SvgBinFilled;